export default {"src":"/_next/static/media/quinsus.04743259.svg","height":32,"width":99,"blurWidth":0,"blurHeight":0};